import { biHottag } from '@tencent/ppd-base-libs';
import { getBiReportPrefix, getBiReportExt } from '../index';
import { i18nGet } from '../i18n';

/**
 * 分转元
 * @param String num
 */
export function fen2yuan(num: string) {
  if ('' === num || undefined === num) {
    return '';
  }

  return (parseInt(num, 10) / 100).toFixed(2);
}

/**
 * 是否过了N天
 *
 * @export
 * @param {Date} date
 * @param {Date} sysDate
 * @param {number} n
 * @returns
 */
export function isNDaysLater(date: Date | undefined, sysDate: Date | undefined, n: number): boolean {
  if (!date) {
    return false;
  }
  const nowDate = sysDate || new Date();
  const nowTime = nowDate.getTime();
  const time = date.getTime();
  const nTime = n * 24 * 60 * 60 * 1000;
  return (nowTime - time) >= nTime;
}

export function formatEnhancedUid(enhancedUid: string) {
  return enhancedUid.replace(/(\d{3})(\d{3})(\d{4})/g, '$1 $2 $3');
}

export function formatTime(time?: string): Date | undefined {
  if (!time) {
    return undefined;
  }
  return new Date(time.replace(/-/g, '/'));
}

export function getExpireTimeTips(timeDate: Date | undefined | string): string {
  if (!timeDate) {
    return '';
  }
  if (typeof timeDate === 'string') {
    timeDate = formatTime(timeDate) as Date;
  }
  const year = timeDate.getFullYear();
  const month = timeDate.getMonth() + 1;
  const mTxt = month < 10 ? `0${month}` : month;
  const date = timeDate.getDate();
  const dtxt = date < 10 ? `0${date}` : date;
  return `${i18nGet('有效期至：')}${year}-${mTxt}-${dtxt}`;
}


export function myBiReport(eventStr: string, extra: any = {}) {
  const { prefix, page } = getBiReportPrefix();
  const env = isInMiniProgram() ? 'mini' : 'wxh5';
  const gExt = getBiReportExt();
  biHottag(`${prefix}.${page}.${eventStr}`.replace(/\.+/g, '.'), Object.assign({
    env,
  }, gExt, extra));
  biHottag(`wallet.cvscomp.hkcv.${eventStr}`.replace(/\.+/g, '.'), Object.assign({
    fsource: prefix,
    env,
  }, gExt, extra));
}

/**
 * 判断是否在小程序
 */
export function isInMiniProgram() {
  // return true;
  // @ts-ignore
  return navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram';
}

export function to<P = Error, T = any>(promise: Promise<T>): Promise<[null, T] | [P, T]> {
  return promise.then(data => [null, data] as [null, T])
    .catch(err => [err, null] as [P, unknown] as [P, T]);
}
